import ModalHeader from '@/components/shared/modals/components/ModalHeader/ModalHeader';
import { IModalComponentProps } from '@/components/shared/modals/Modals.interfaces';
import Link from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './ModalFAQ.module.scss';

export const ModalFAQ: FC<IModalComponentProps> = ({ onClose }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.modal}>
			<ModalHeader title="FAQ" close={onClose} />
			<div className={styles.content}>
				<h3>{t('1-how-can-i-contribute-to-the')}</h3>
				<p>{t('you-can-contribute-in-two-ways')}</p>
				<p>
					{`${t('to-submit-a-story-for-our-virt')} `}
					<Link href={{ query: { open: 'share-story' } }} shallow={true} className="link">
						{`${t('simply-pin-the-place-where-it')} `}
					</Link>
					{t('if-you-wish-to-keep-it-away-fr')}
				</p>
				<p>
					<Link href={{ query: { open: 'contribute' } }} shallow={true} className="link">
						{`${t('to-send-a-physical-contributio')} `}
					</Link>
					{t('follow-further-instructions-o')}
				</p>
				<h3>{t('2-when-i-wish-to-contribute-a')}</h3>
				<p>
					{`${t('generally-you-should-fill-in')} `}
					<Link href={{ query: { open: 'contribute' } }} shallow={true} className="link">
						{t('global-collection-in-zagreb')}
					</Link>
					{t('sometimes-however-our-webs')}
				</p>
				<h3>{t('3-will-my-virtual-contributio')}</h3>
				<p>{t('a-few-days-may-pass-before-the')}</p>
				<h3>{t('4-will-my-donated-item-be-exh')}</h3>
				<p>{t('there-is-no-rule-regarding-the')}</p>
				<p>{t('we-would-kindly-ask-you-to-tak')}</p>
				<h3>{t('5-will-my-donation-be-exhibit')}</h3>
				<p>{t('yes-each-exhibit-is-showcased')}</p>
				<h3>{t('6-do-i-have-to-give-my-full-n')}</h3>
				<p>{t('yes-by-stating-your-full-name')}</p>
				<h3>{t('7-does-the-contribution-have')}</h3>
				<p>{t('our-diverse-collection-imposes')}</p>
				<h3>{t('8-what-exactly-is-the-story')}</h3>
				<p>{t('the-story-is-your-own-creation')}</p>
				<p>{t('there-are-no-restrictions-rega')}</p>
				<p>{t('since-it-is-our-duty-to-provid')}</p>
				<h3>{t('9-in-which-language-should-i')}</h3>
				<p>{t('since-we-express-ourselves-bes')}</p>
				<p>{t('if-your-contribution-is-exhibi')}</p>
				<h3>{t('10-will-i-be-informed-of-the')}</h3>
				<p>{t('as-a-rule-we-tend-to-accept-al')}</p>
				<p>{t('since-all-stories-are-displaye')}</p>
				<h3>{t('11-can-i-personally-deliver-t')}</h3>
				<p>{t('yes-it-is-important-that-the')}</p>
				<h3>{t('12-what-if-i-havent-found-th')}</h3>
				<p>
					{`${t('write-to-us-at')} `}
					<a className="link" href={'mailto:museum.collection@brokenships.com'}>
						{'museum.collection@brokenships.com'}
					</a>
					{'.'}
				</p>
			</div>
		</div>
	);
};
